import { Injectable } from '@angular/core';
import { RECEIPTWORTHMAPPING } from './receiptWorhMapping.data';

@Injectable()
export class ReceiptWorthMappingService {
  constructor() { }

  public mapWorthToWords(worth: number): string {
    let worthString: string = '';
    const worthSplits = worth.toString().split('');

    if (worthSplits.length === 4) {
      return 'eintausend';
    }

    const firstNumber = parseInt(worthSplits[0]);
    const secondNumber = parseInt(worthSplits[1]);
    const thirdNumber = parseInt(worthSplits[2]);

    if (firstNumber > 1) {
      worthString += `${RECEIPTWORTHMAPPING[firstNumber]}hundert`;
    } else {
      worthString += `${RECEIPTWORTHMAPPING[firstNumber].replace('s', '')}hundert`;
    }

    if (secondNumber === 0 && thirdNumber === 0) {
      return worthString;
    }

    if (secondNumber === 0) {
      worthString += `${RECEIPTWORTHMAPPING[thirdNumber]}`;
    } else if (secondNumber === 1) {
      const secondAndThirdNumber = `${secondNumber}${thirdNumber}`;
      worthString += `${RECEIPTWORTHMAPPING[secondAndThirdNumber]}`;
    } else {
      const secondNumberPotential = secondNumber * 10;

      if (thirdNumber === 1) {
        worthString += `${RECEIPTWORTHMAPPING[thirdNumber].replace('s', '')}und${RECEIPTWORTHMAPPING[secondNumberPotential]}`;
      } else if (thirdNumber === 0) {
        worthString += `${RECEIPTWORTHMAPPING[secondNumberPotential]}`;
      } else {
        worthString += `${RECEIPTWORTHMAPPING[thirdNumber]}und${RECEIPTWORTHMAPPING[secondNumberPotential]}`;
      }
    }

    return worthString;
  }
}



// WEBPACK FOOTER //
// ./src/app/checkout/receiptWorthMapping.service.ts